interface Props {
  color?: string;
}

const LogoutIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V15.25L18.002 16.7481V20H6V4H18V7.25L20 8.75V4C20 2.897 19.103 2 18 2H6ZM16 8.25V11H11V13H16V15.75L21 12L16 8.25Z"
        fill={color}
      />
    </svg>
  );
};

export default LogoutIcon;
